// Keycloak 26.7.3 (CVE-2026-18209) rejects redirect URIs that carry OIDC response parameters,
// in the query string or the fragment, with "Invalid redirect uri". Keycloak leaves its callback
// parameters in the address bar, so any URI derived from window.location has to be stripped
// before it is handed back to the authorize or logout endpoint.
const FORBIDDEN_OIDC_PARAMS = [
  "state",
  "code",
  "session_state",
  "iss",
  "error",
  "error_description",
  "access_token",
  "id_token",
  "token_type",
  "expires_in",
  "kc_action_status",
] as const satisfies ReadonlyArray<string>;

const isForbiddenParam = (name: string): boolean =>
  FORBIDDEN_OIDC_PARAMS.some(
    (forbidden) => forbidden === name.trim().toLowerCase(),
  );

type OidcSafeRedirectUri = (url: string) => string;

const oidcSafeRedirectUri: OidcSafeRedirectUri = (url) => {
  const parsed = new URL(url);

  // The fragment is opaque to URL, and Keycloak matches on the raw name, so drop it entirely
  // rather than trying to filter it parameter by parameter.
  parsed.hash = "";

  for (const name of [...parsed.searchParams.keys()]) {
    if (isForbiddenParam(name)) {
      parsed.searchParams.delete(name);
    }
  }

  return parsed.toString();
};

export default oidcSafeRedirectUri;
